import React, { useState, useEffect } from 'react';

import '../styles/Home.css';
import '../styles/Emarket.css';
import '../styles/Responsive.css';

import Footer from '../components/Footer.js'
import { FaArrowRightFromBracket, FaChevronRight, FaCreditCard, FaShop } from 'react-icons/fa6';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { FaShare } from 'react-icons/fa';

export default function Emarket() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [carouselData, setCarouselData] = useState([
    {
      text: "Ease of Doing Business",
      image: "https://images.pexels.com/photos/1181396/pexels-photo-1181396.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      description: "Offers an easy and efficient way to connect with a broad network of vendors and suppliers. By providing a truly digital online marketplace, businesses can streamline procurement processes and access a larger pool of potential partners, enhancing their ease of doing business."
    },
    {
      text: "Performance Alignment",
      image: "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      description: "The CANTO eMarket procurement system helps entities achieve improved accountability for performance, spending control, and sales metrics. The platform aligns procurement processes with KPIs and business goals, enabling greater accountability, transparency, and efficiency."
    },
    {
      text: "Digital Value-Streams",
      image: "https://images.pexels.com/photos/3861458/pexels-photo-3861458.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      description: "Offers organizations an opportunity to leverage digital technology to digitize their non-digital processes and unlock new value streams such as increased efficiency, innovation, competitive advantages, improved customer experiences, and reduced time-to-market."
    },
    {
      text: "Secure and Transparent Platform for Transactions",
      image: "https://images.pexels.com/photos/60504/security-protection-anti-virus-software-60504.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      description: "Offers a secure and transparent platform for transactions, ensuring the safety and trust of vendors and suppliers. With a reliable and trustworthy system in place, organizations can focus on growing their operations and serving their customers."
    }
  ]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselData.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselData.length) % carouselData.length);
  };

  useEffect(() => {
    
    const timer = setTimeout(() => setIsVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  const Carousel = () => {
    
    return (
      <div className="carousel-container">
        <div className="carousel">
          <div className="carousel-content">
            {/* Text content */}
            <div className="text-content">
              <div>
                <h2>{carouselData[currentSlide].text}</h2>
                <div className='carousel-description'>{carouselData[currentSlide].description}</div>
              </div>
              <div className="navigation-buttons">
                <button onClick={prevSlide} className="nav-button">
                  <ChevronLeft size={24} />
                </button>
                <button onClick={nextSlide} className="nav-button">
                  <ChevronRight size={24} />
                </button>
              </div>
            </div>
            
            {/* Image content */}
            <div className="image-content">
              <img
                src={carouselData[currentSlide].image}
                alt={carouselData[currentSlide].text}
              />
            </div>
          </div>
        </div>
      </div>
    );
};

  return (
    <div className='container'>
      <div className='emarket-landing-container' style={{backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/eMarket_banner.png'})`, backgroundSize: 'cover'}}>
        {/* <div className={`emarket-landing-content ${isVisible ? 'visible' : ''}`}>
            <div className='emarket-landing-title'>
                CANTO 
                E-MARKET
            </div>
            <div className='emarket-landing-info'>
                Canto eMarket is an innovative online marketplace dedicated to connecting buyers and sellers in the digital age. Our platform serves as a virtual hub for a diverse range of products and services, catering to both local and global audiences.
            </div>
            <div className='emarket-landing-c2a'>
              <a className='emarket-landing-buyer' href='https://cantoemarket.org/' target='_blank'>
                Visit E-Market <FaArrowRightFromBracket size={18} color={'#fff'} style={{marginLeft: '10px'}}/>
              </a>
            </div>
        </div> */}
      </div>

      <div style={{width: '100%'}}>
        { Carousel() }
      </div>

      <div className='emarket-contact-container'>
        <div className='emarket-contact'>
          <div className='emarket-contact-title'>
            Want to learn more? 
          </div>

          <div className='emarket-contact-sub'>Schedule a meeting with us or submit your questions.</div>

          <div className='emarket-contact-input-container'>
            <div className='emarket-contact-input-item'>
              <div className='emarket-contact-input-pre'>
                Name
              </div>
              <input className='emarket-contact-input' type='text' placeholder='Enter your Name...'/>
            </div>

            <div className='emarket-contact-input-item'>
              <div className='emarket-contact-input-pre'>
                Email
              </div>
              <input className='emarket-contact-input' type='text' placeholder='Enter your Name...'/>
            </div>

            <div className='emarket-contact-input-item'>
              <div className='emarket-contact-input-pre'>
                Message
              </div>
              <textarea className='emarket-contact-input area' placeholder=''/>            
            </div>

            <div className='emarket-contact-btn-wrapper'>
              <div className='emarket-contact-btn'>
                Send 
                <div className='emarket-contact-btn-icon'>
                    <FaChevronRight size={16} color='#fff'/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='emarket-contact-info-container'>
          <img src={process.env.PUBLIC_URL + './assets/contact_vector.png'} className='emarket-contact-image'/>
        </div>
      </div>

    </div>
  )
}
